import Lottie from 'lottie-react';
import React from 'react';

const animationData = {
    nm: 'Main Scene',
    ddd: 0,
    h: 500,
    w: 500,
    meta: { g: '@lottiefiles/creator 1.22.0' },
    layers: [
        {
            ty: 4,
            nm: 'Shape Layer - SVG',
            sr: 1,
            st: 0,
            op: 50,
            ip: 0,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: { a: 0, k: [16, 16] },
                s: { a: 0, k: [1562.5, 1562.5] },
                sk: { a: 0, k: 0 },
                p: { a: 0, k: [250, 250] },
                r: {
                    a: 1,
                    k: [
                        {
                            o: { x: 0.167, y: 0.167 },
                            i: { x: 0.833, y: 0.833 },
                            s: [0],
                            t: -23,
                        },
                        {
                            o: { x: 0.167, y: 0.167 },
                            i: { x: 0.833, y: 0.833 },
                            s: [0],
                            t: 0,
                        },
                        { s: [360], t: 50 },
                    ],
                },
                sa: { a: 0, k: 0 },
                o: { a: 0, k: 100 },
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    nm: 'Group 1',
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            nm: 'Path 1',
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [0, 0],
                                        [8.8366, 0],
                                        [0, 8.8366],
                                        [-8.83656, 0],
                                        [0, -8.83656],
                                    ],
                                    o: [
                                        [0, 8.8366],
                                        [-8.83656, 0],
                                        [0, -8.83656],
                                        [8.8366, 0],
                                        [0, 0],
                                    ],
                                    v: [
                                        [32, 16],
                                        [16, 32],
                                        [0, 16],
                                        [16, 0],
                                        [32, 16],
                                    ],
                                },
                            },
                        },
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            nm: 'Path 2',
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [0, 0],
                                        [-6.627420000000001, 0],
                                        [0, 6.6274000000000015],
                                        [6.6274000000000015, 0],
                                        [0, -6.627420000000001],
                                    ],
                                    o: [
                                        [0, 6.6274000000000015],
                                        [6.6274000000000015, 0],
                                        [0, -6.627420000000001],
                                        [-6.627420000000001, 0],
                                        [0, 0],
                                    ],
                                    v: [
                                        [4, 16],
                                        [16, 28],
                                        [28, 16],
                                        [16, 4],
                                        [4, 16],
                                    ],
                                },
                            },
                        },
                        {
                            ty: 'gf',
                            bm: 0,
                            hd: false,
                            nm: 'Fill',
                            e: { a: 0, k: [32, 16] },
                            g: {
                                p: 2,
                                k: {
                                    a: 0,
                                    k: [
                                        0, 1, 0.3686274509803922,
                                        0.18823529411764706, 1,
                                        0.807843137254902, 1,
                                        0.34509803921568627,
                                    ],
                                },
                            },
                            t: 1,
                            a: { a: 0, k: 0 },
                            h: { a: 0, k: 0 },
                            s: { a: 0, k: [0.00000179677, 16] },
                            r: 1,
                            o: { a: 0, k: 100 },
                        },
                        {
                            ty: 'tr',
                            a: { a: 0, k: [0, 0] },
                            s: { a: 0, k: [100, 100] },
                            sk: { a: 0, k: 0 },
                            p: { a: 0, k: [0, 0] },
                            r: { a: 0, k: 0 },
                            sa: { a: 0, k: 0 },
                            o: { a: 0, k: 100 },
                        },
                    ],
                },
            ],
            ind: 1,
        },
    ],
    v: '5.7.0',
    fr: 30,
    op: 50,
    ip: 0,
    assets: [],
};

const colorfulSpinnerAnimation = ({
    loop = true,
    size = '64px',
}: {
    loop?: boolean;
    size?: string;
}) => (
    <div className="text-container">
        <Lottie
            animationData={animationData}
            loop={loop}
            allowFullScreen={true}
            rendererSettings={{ preserveAspectRatio: 'none' }}
            style={{ width: size, height: size }}
        />
    </div>
);

export default colorfulSpinnerAnimation;
